<template>
  <FormulateInput
    type="textarea"
    v-model="_value"
    v-bind="$attrs"
    :label="label"
    :validation="validation"
    :placeholder="placeholder"
    :help="help"
    class="ews-input"
    outerClass=""
    :wrapperClass="wrapperClass"
    :elementClass="elementClass"
    :inputClass="['form-textarea block', inputClass]"
    labelClass="text-gray-700 font-semibold text-base ml-2 mb-1 inline-block"
    helpClass="text-cool-gray-500 font-light text-sm ml-1"
    errorClass="text-red-700 font-light text-sm ml-1"
  />
</template>

<script>
// import Vue from 'vue'
// import VueFormulate from '@braid/vue-formulate'
// Vue.use(VueFormulate)

export default {
  name: 'FormTextarea',
  components: {},
  inheritAttrs: false,
  props: {
    /**
     * Optional label above the text area.
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Placeholder text.
     */
    placeholder: {
      type: String,
      default: ''
    },
    /**
     * Use `v-model` to set value prop.
     */
    value: [String, Number],
    /**
     * Help text displayed after the element.
     */
    help: String,
    /**
     * CSS classes for wrapper div around textarea.
     */
    wrapperClass: {
      type: String,
      default: ''
    },
    /**
     * CSS classes on the input and label grouping.
     * Set this to `flex` to make the options inline instead of block.
     */
    elementClass: {
      type: String,
      default: ''
    },
    /**
     * Validation rules.
     */
    validation: {
      type: String
    },
    /**
     * CSS classes for text area input.
     */
    inputClass: {
      type: String,
      default: 'w-full'
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style></style>
